import {
    EventLeaderboardDataReturn,
    EventsApi,
    FreeplayEntry,
    FreeplayEvent,
    GetEventReturn,
    PlayerCreateBetDTO,
} from "@freeplay/shared-code";

export class EventsAPIWrapper {
    public ready: Promise<boolean>;
    private readyResolve: (value: boolean) => void;

    // ! means we're not setting this in constructor
    private api!: EventsApi;
    private tenantSlug!: string;
    private token = "";

    constructor() {
        this.readyResolve = () => {
            /* no-op */
        };
        this.ready = new Promise((resolve) => {
            this.readyResolve = resolve;
        });
    }

    public init(api: EventsApi, token: string, tenantSlug: string): void {
        this.api = api;
        this.token = token;
        this.tenantSlug = tenantSlug;
        this.readyResolve(true);
    }

    public clearUser(): void {
        this.token = "";
    }

    public async getAllActiveEvents(): Promise<FreeplayEvent[]> {
        await this.ready;
        return await this.api.eventsControllerV1GetAllActiveEvents(this.tenantSlug, {
            fetch,
        });
    }

    public async getEvent(eventId: number): Promise<GetEventReturn> {
        await this.ready;
        return await this.api.eventsControllerV1GetOneEvent(eventId, this.tenantSlug, this.getOptions());
    }

    public async getLeaderboardForEvent(eventId: number): Promise<EventLeaderboardDataReturn[]> {
        await this.ready;
        return await this.api.eventsControllerV1GetLeaderboardForEvent(eventId, this.tenantSlug);
    }

    public async getEventHistory(): Promise<FreeplayEntry[]> {
        await this.ready;
        return await this.api.eventsControllerV1GetPlayerHistory(this.tenantSlug, this.getOptions());
    }

    public async submitPicksForEvent(eventId: number, picks: PlayerCreateBetDTO): Promise<FreeplayEntry> {
        await this.ready;
        return await this.api.eventsControllerV1AddPicks(picks, eventId, this.tenantSlug, this.getOptions());
    }

    private getOptions() {
        return {
            headers: {
                Authorization: `Bearer ${this.token}`,
            },
        };
    }
}
